<template>
  <div>
    <header>
      <Header />
    </header>

    <div id="main">
      <section class="spExhibition">
        <div class="spExhibitionTitle">
          <div class="inner4">
            <h1>協賛展示</h1>
            <p class="titleSub">Exhibitions by Sponsors</p>
          </div><!-- /inner4-->
        </div><!-- /spExhibitionTitle-->

        <div class="spExhibitionAbout">
          <div class="inner4">
            <p>
              サポート企業様、省庁・自治体様のご提供によるオンライン特別展示です。各企業様、省庁・自治体様より、珠玉の作品を選定いただきました。ここにも、世界のあらゆる美しさとの出会いを表現した作品が展示されています。是非お目通しいただき、作品をより深く味わってみてください。スマートフォンの画面で鑑賞した方は、ぜひパソコンやタブレットなどの大きい画面でもお楽しみください。
            </p>
          </div><!-- /inner-->
        </div><!-- /talkshowAbout-->

        <div v-if="!isDemo()" class="spExhibitiontBody">
          <div class="inner2">

            <!-- 協賛一覧 -->
            <template v-for="winner of sponsorList()">
              <div :key="winner.id" class="spExhibitiontBlock" :class="'cl' + winner.id">
                <div class="spExhibitiontBlockImg"><router-link :to="workUrl(winner)"><img class="spExhibitionLogo" v-if="winner.profileImageUrl"
                      :src="winner.profileImageUrl" :alt="winner.name" @load="addSponsorLogoClass('imgSponsorLogo' + winner.id)" :ref="'imgSponsorLogo' + winner.id" /></router-link></div>
                <h2>{{winner.name}}</h2>
              </div><!-- /listBlock-->
            </template>

            <!-- 手動レイアウトが必要になった場合のサンプル -->
            <!--
            <div class="spExhibitiontBlock">
              <div class="spExhibitiontBlockImg"><router-link to="/sponsors/99992"><img class="spExhibitionLogo horizontal"
                    :src="this.getSp(99992, 'profileImageUrl')" :alt="this.getSp(99992, 'name')" /></router-link></div>
              <h2>{{this.getSp(99992, 'name')}}</h2>
            </div>
            -->

          </div><!-- /inner-->
        </div><!-- /spExhibitiontBody-->
        <div v-else style="height: 500px; color: black; font-size: 3rem; padding-top: 100px; text-align: center;">
          Coming Soon
        </div>
      </section><!-- /spExhibition-->
    </div><!-- /main-->
    <Footer />
    <div class="actionMenu" :class="{ addRightMargin: false, portfolioLayout: false }">
      <UpButton />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Header from '@/components/modules/Header.vue'
import Footer from '@/components/modules/Footer.vue'
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'
import UpButton from '@/components/modules/UpButton.vue'

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  components: {
    Header,
    Footer,
    UpButton
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'winners'
    ])
  },
  methods: {
    isDemo () {
      return process.env.VUE_APP_DEMO_HOST ? (location.host.indexOf(process.env.VUE_APP_DEMO_HOST) >= 0) : false
    },
    getSp (id, key) {
      for (const winner of this.sponsorList()) {
        if (winner.id === id) {
          return winner && winner[key] ? winner[key] : ''
        }
      }
      return ''
    },
    setTitleAndDescription (to) {
      document.title = (to.meta.title ? to.meta.title : '')
      document.querySelector("meta[name='description']").setAttribute('content', (to.meta.desc ? to.meta.desc : ''))
    },
    sponsorList () {
      return this.winners.filter((winner) => { return winner.awardType === this.EnumAwardTypeSpecialExhibitons })
    },
    // ロゴ画像の縦横サイズを考慮して、クラスをセットする処理
    // 縦位置:vertical、横位置:horizontal、正方形:square
    addSponsorLogoClass (ref) {
      var img = new Image();
      img.onload = () => {
        let addClass = 'horizontal'
        if(img.width === img.height) {
          addClass = 'square'
        } else if (img.width < img.height) {
          addClass = 'vertical'
        }
        this.$refs[ref][0].classList.value = this.$refs[ref][0].classList.value + ' ' + addClass
      }
      img.src = this.$refs[ref][0].src
    },
    workUrl (winner) {
      return `/sponsors/${winner.id}`
    }
  },
  created () {
  },
  mounted () {
    // titleとdescriptionの設定
    this.setTitleAndDescription(this.$route)
  },
  watch: {
  }
}
</script>

<style scoped>
</style>
